import React from "react";
import { Label } from "reactstrap";
import { RadioButton } from "primereact/radiobutton";

const VerifyServiceInfo = ({
  showVerifyOptions,
  verifyServiceOptIn,
  setVerifyServiceOptIn,
}) => (
  <div>
    <p>
      <i>
        Verify<sup>™</sup>
      </i>
      , VDA’s comprehensive maintenance management program, provides detailed
      insight into the status of your elevator systems including:
    </p>
    <ul style={{ textAlign: "left", marginLeft: "2em" }}>
      <li>
        Verification that your elevator contractor is fulfilling the obligations
        of their maintenance agreement
        <br />
        (e.g., maintenance hours, repairs, response times)
      </li>
      <li>
        Reliability &amp; performance metrics as compared to industry standards
      </li>
      <li>Compliance with annual testing requirements</li>
      <li>Tracking deficiency and violation corrections</li>
      <li>Review and commenting of all invoices</li>
      <li>Capital planning</li>
    </ul>
    <p>
      <i>
        Verify<sup>™</sup>
      </i>{" "}
      is effective in enhancing the elevators’ reliability, safety, compliance,
      and longevity while mitigating shutdowns, violations, penalties, and
      unexpected or errant invoices.
    </p>
    <p>Let us know if you are interested in further details and pricing.</p>

    {showVerifyOptions && (
      <div
        style={{
          marginTop: "1.5em",
          marginBottom: "1em",
          textAlign: "left",
        }}
      >
        <Label style={{ marginRight: "1em" }}>
          <b>
            Are you interested in Verify<sup>™</sup>?
          </b>
        </Label>
        <span style={{ marginRight: "2em" }}>
          <RadioButton
            inputId="verify-yes"
            name="verifyServiceOptIn"
            value={true}
            checked={verifyServiceOptIn === true}
            onChange={() => setVerifyServiceOptIn(true)}
          />
          <Label
            htmlFor="verify-yes"
            style={{ marginLeft: "0.5em", marginRight: "1.5em" }}
          >
            Yes
          </Label>
        </span>
        <span>
          <RadioButton
            inputId="verify-no"
            name="verifyServiceOptIn"
            value={false}
            checked={verifyServiceOptIn === false}
            onChange={() => setVerifyServiceOptIn(false)}
          />
          <Label htmlFor="verify-no" style={{ marginLeft: "0.5em" }}>
            No
          </Label>
        </span>
      </div>
    )}
  </div>
);

export default VerifyServiceInfo;
